module.exports = __webpack_public_path__ + "static/media/ciprian_mihai_paius.b527df25.png";